import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../globals';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private globals: Globals) { }

  login(username: string, password: string) {

    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/auth/${username}/${password}`);
  }
  getUserOptions(un: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secuseroptions/${un}`);
  }

  getUserRoles(un: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secuserrolesbyusername/${un}`);
  }

  validateCandByUuid(uuid: string) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/authregistration/${uuid}`);
  }
}
